import { Parser } from 'html-to-react'
import { useEffect, useMemo, useRef } from 'react'
import { kHighlightClassName } from '../highlight-passages'
import { highlightReferenceHtml } from '../reference-html'

type ReferenceHtmlRendererProps = {
  htmlContent: string
  passages: string[]
}

/** Render a matter file's HTML with each cited passage highlighted once, scrolled to the first highlight. */
export default function ReferenceHtmlRenderer(props: ReferenceHtmlRendererProps): JSX.Element {
  const { htmlContent, passages } = props
  const containerRef = useRef<HTMLDivElement>(null)

  const parsedHtml = useMemo(() => Parser().parse(highlightReferenceHtml(htmlContent, passages)), [htmlContent, passages])
  const hasPassages = passages.length > 0

  useEffect(() => {
    if (!hasPassages) return
    // Wait for the document to lay out before scrolling.
    const timer = setTimeout(() => {
      containerRef.current?.querySelector(`.${kHighlightClassName}`)?.scrollIntoView({ behavior: 'smooth', block: 'center' })
    }, 250)
    return () => clearTimeout(timer)
  }, [hasPassages, parsedHtml])

  return (
    <div className="relative h-full flex flex-col items-center p-3 animate-fadeIn">
      <div ref={containerRef} className="view-container gcs-md-highlights flex-grow border bg-white w-full">
        {parsedHtml}
      </div>
      <div>&nbsp;</div>
    </div>
  )
}
